module.exports = __webpack_public_path__ + "static/media/bettr-settings.10408d2a.png";